import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import Image from 'next/image';

import styles from './partners.module.css';

export function Partners({ partners }: { partners: TDynamicData[] }) {
  if (!partners?.length) return null;

  const doubled = [...partners, ...partners];

  return (
    <section className="select-none py-8">
      <div className={styles.wrapper}>
        <div className={styles.track}>
          {doubled.map((partner, i) => (
            <div
              key={i}
              className="flex flex-shrink-0 items-center justify-center px-10"
              aria-hidden={i >= partners.length ? true : undefined}
            >
              {partner?.image?.url && (
                <Image
                  src={partner.image.url}
                  alt={resolveImageAlt(
                    partner?.image,
                    i < partners?.length ? (partner?.name ?? '') : '',
                  )}
                  width={200}
                  height={80}
                  className="h-[52px] w-auto object-contain sm:h-14 md:h-16 lg:h-20"
                  draggable={false}
                  loading={i < 4 ? 'eager' : 'lazy'}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
